import axios from 'axios'
import { PinBoard } from '../models/pinboard.model';
import { BaseService } from './base.service';

class PinBoardService extends BaseService{

    constructor(){
        super();
        console.log("created a instance of pinboardService");
    }

    async delete(id: number){
        let result = await axios.delete(`${this.api}pinboard/Delete?id=${id}`);
        return result;
        // return this.execute('delete', `pinboard/${id}`);
    }

    async getListOnCompany(companyId: string){
        return axios.get(`${this.api}pinboard/GetListOnCompany?companyId=${companyId}`).then(req => { return req.data });
        // return this.execute('delete', `pinboard/${id}`);
    }

    async getAll(query:any){
        return axios.get(`${this.api}pinboard/GetList?companyId=${query}`).then(req => { return req.data });
        // return this.execute('get', 'pinboard/');
    }
    async getAllKeyValue(query:any){
        return axios.get(`${this.api}pinboard/GetKeyValueList?companyId=${query}`).then(req => { return req.data });
        // return this.execute('get', 'pinboard/');
    }

    async getCount(){
        return axios.get(`${this.api}pinboard/count`).then(req => { return req.data });
    }

    async get(id: number){
        return axios.get(`${this.api}pinboard/Get?id=${id}`).then(req => { return req.data });
        // return this.execute('get', `pinboard/${id}`);
    }

    async create(pinboard: PinBoard){
        let result = await axios.post(`${this.api}pinboard/Create`, pinboard);
        return result;
        // return this.execute('post', `pinboard/`, pinboard);
    }

    async update(pinboard: PinBoard){
        let result = await axios.put(`${this.api}pinboard/Update`, pinboard);
        return result;
        // return this.execute('put', `pinboard/${pinboard.id}`, pinboard);
    }
}

export const pinboardService = new PinBoardService();

